import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h8.172a2 2 0 0 0 1.414-.586l5.828-5.828A2 2 0 0 0 21 13.172V5a2 2 0 0 0-2-2zm8 16 6-6h-4a2 2 0 0 0-2 2z",
      clipRule: "evenodd"
    }
  )
);
var SvgNotesFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var NotesFilled_default = SvgNotesFilled;

export { NotesFilled_default as default };
